import { optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

const computationRules = (formData, key) => {
  let returnResult = {};
  console.log('key',key);
  if(key!=='activity_status'){
  
  // Check current activity status
  const currentActivityStatus = formData.activity_status || 'Not Started';
  
  // If activity status is "Not Started" and any field is being changed, set to "In Progress"
  // if (currentActivityStatus === 'Not Started' && key) {
  //   returnResult.activity_status = 'Ordered';
  // }
  
  // Check if any Dispensed Details checkbox is selected
  const dispensedDetailsFields = [
    'device_inspected',
    'accessories_included',
    'acknowledgment_signed',
    'order_verified'
  ];
  
  const hasAnyDispensedDetail = dispensedDetailsFields.some(field => {
    const value = formData[field];
    return value === true || value === 1 || value === '1' || value === 'true';
  });
  
  // If any dispensed detail is checked, auto-update statuses
  if (hasAnyDispensedDetail) {
    returnResult.status = 'Dispensed';
    returnResult.activity_status = 'Completed';
  }
  }
  
  return returnResult;
}

export const DMEScreen = (props) => {
  console.log('dme props',props);
  const charts = [
    {
      type: "Grid",
      col: "col-md-3",
      data: [
        {
          type: "PatientDetails",
          employeeDetails: props.employeeDetails,
          visitDetails: props.visitDetails,
        },
        {
          type: "CompanyDetails",
          companyDetails: props.companyDetails,
        },
      ],
    },
    {
      type: "Tab",
      col: "col-md-9",
      data: [
        {
          id: "dispensed_details",
          data: [
            {
              label: "Dispensed Details",
              fields: [
                 {
                   label: "Dispensed Details :",
                  col: "col-12",
                  type: "CheckBoxGroup",
                  name: "dispensed_details",
                  //   isMulti: true,
                  id: "dispensed_details",
                  options: [
                    {
                      label: "Device inspected and safe",
                      name: "device_inspected",
                    },
                    { label: "Accessories included (if any)", name: "accessories_included" },
                    { label: "Acknowledgment of Receipt signed", name: "acknowledgment_signed" },
                    { label: "Verified order & charge entered into system", name: "order_verified" },
                  ],
                },
                  {
                      label: "Inventory #:",
                      col: "col-12",
                      type: "TextInput",
                      name: "inventory_number",
                  },
              ],
            },
            {
              label: " Instructions Given",
              fields: [
                 {
                   label: " Instructions Given :",
                  col: "col-12",
                  type: "CheckBoxGroup",
                  name: "instructions_given",
                  //   isMulti: true,
                  id: "instructions_given",
                  options: [
                    {
                      label: "How to take on and off",
                      name: "instruction_take_on_off",
                    },
                    { label: "When to wear", name: "instruction_when_to_wear" },
                    { label: "Weightbearing status (if applicable)", name: "instruction_weight_bearing" },
                    { label: "Skin checks", name: "instruction_skin_checks" },
                    { label: "Cleaning & care", name: "instruction_cleaning_care" },
                    { label: "Warning signs to return", name: "instruction_warning_signs" },
                  ],
                },
              ],
            },
              {
              label: "Patient Tolerance",
              fields: [
                 {
                   label: "Patient Tolerance:",
                  col: "col-12",
                  type: "CheckBoxGroup",
                  name: "patient_tolerance",
                  //   isMulti: true,
                  id: "patient_tolerance",
                  options: [
                    {
                      label: "Tolerated fitting well",
                      name: "tolerance_fitting_well",
                    },
                    { label: "Ambulated safely with device (if applicable)", name: "tolerance_ambulated_safely" },
                    { label: "Verbalized understanding", name: "tolerance_understanding" },
                  ],
                },
              ],
            },
                  {
                          label: "Review / Completion",
                          col: "col-12",
                          fields: [
                            {
                              type: "ProviderSignOff",
                              col: "col-12",
                              fields: [
                                { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                                {
                                  label: "Signature",
                                  type: "NewSignature",
                                  name: "provider_signature",
                                  col: "col-12",
                                },
                                { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                                // { label: "Suggested Result", disabled:true, type: "TextInput", name: "suggested_status", col: "col-6" },
                                {
                                  label: "Final Results",
                                  type: "SelectList",
                                  col: "col-12",
                                  name: "status",
                                  statusBasedColor: true,
                                  // Previous options:
                                  // options: [
                                  //   { label: "Not Dispensed", value: "Not Dispensed" },
                                  //   { label: "Dispensed", value: "Dispensed" },
                                  // ],
                                  // New standard options:
                                  options: optionsToKeyValuePairs(
                                    [
                                      "Not Started",
                                      "Pending",
                                      "Normal",
                                      "Abnormal",
                                      "Negative",
                                      "Positive",
                                      "Dispensed",
                                      "Administered",
                                      "Failed",
                                      "Passed",
                                      "Non-Negative",
                                      "Cancelled",
                                      "Inconclusive",
                                    ],
                                    false
                                  ),
                                },
                                {
                                  label:"Activity Status",
                                  type: "SelectList",
                                  name: "activity_status",
                                  col: "col-12",
                                  statusBasedColor: true,
                                  // Previous options:
                                  // options: optionsToKeyValuePairs(['Not Started', 'Ordered', 'Completed', 'Cancelled']),
                                  // New standard options:
                                  options: optionsToKeyValuePairs(
                                    [
                                      "Not Started",
                                      "Pending",
                                      "Pending Lab Confirmation",
                                      "Pending MRO Confirmation",
                                      "Ready for Review",
                                      "Completed",
                                      "Cancelled",
                                    ],
                                    false
                                  )
                                },
                              ],
                            },
                            {
                              label: "Provider Notes",
                              col: "col-12",
                              type: "TextArea",
                              name: "notes",
                            },
                            // {
                            //   label: "Status",
                            //   type: "SelectList",
                            //   options: [
                            //     { label: "Not Started", value: "Not Started" },
                            //     { label: "Pending", value: "Pending" },
                            //     { label: "Failed", value: "Failed" },
                            //     { label: "Passed", value: "Passed" },
                            //   ],
                            //   name: "status",
                            // },
                          ],
                        },
         
          ],
        },
        {
          id: 'Images',
          label: 'Images',
          data: []
        }
      ],
    },
  ];
  const defaultValue = {
    status: "Not Started",
    suggested_status: "Not Started",
    activity_status: "Not Started",
    // reason:'Pre-employment'
  };
  const buttons = {};
  const headers = [{
    type: 'Tab',
    data: [
      {
        label: 'Dispensed Details',
        id: 'dispensed_details'
      },
      {
        label: 'Images',
        id: 'Images'
      }
    ]
  }];
  return {
    charts,
    defaultValue,
    buttons,
    headers,
    computationFunction: (formData, key) => ({
      ...computationRules(formData, key),
      ...computationRules1(formData, key),
    }),
  };
};